import { Guid } from "@/types"
import Notification, { IGetNotification, NotificationType } from "./Notification"
import NotificationAsset from "./NotificationAsset"

export interface IGetNotificationAssetMaintenanceOperationHoursOverdueSoonDto extends IGetNotification {
    notificationType: NotificationType.assetMaintenanceOperationHoursOverdueSoon
    assetId: Guid
    maintenanceTypeName: string
}

export default class NotificationAssetMaintenanceOperationHoursOverdueSoon extends Notification {
    maintenanceTypeName: string
    asset: NotificationAsset

    constructor(dto: IGetNotificationAssetMaintenanceOperationHoursOverdueSoonDto) {
        super(dto)
        this.maintenanceTypeName = dto.maintenanceTypeName
        this.asset = new NotificationAsset({
            assetId: dto.assetId
        })
    }
}
